module.exports = __webpack_public_path__ + "static/media/agros.280b442c.png";